import { type ReactElement } from 'react';
import { type ButtonProps, Button as ReactAriaButton } from 'react-aria-components';

export type DialogButtonProps = ButtonProps;

export function DialogButton(props: DialogButtonProps): ReactElement {
  return <ReactAriaButton {...props} />;
}
